import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GatewaySessionTokenState } from './gateway-session-token.state';

export const selectGatewaySessionTokenState = createFeatureSelector<GatewaySessionTokenState>('gatewaySessionToken');

export const selectGatewaySessionToken = createSelector(selectGatewaySessionTokenState, (state) => state.token);

export const selectIsGatewaySessionTokenLoaded = createSelector(selectGatewaySessionTokenState, (state) => state.loaded && !state.errorLoading);
